<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.CREATE') }} {{ $t('BOOKING.RESOURCES.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>

    <v-card class="mt-3">
      <v-card-text>
        <v-form v-model="valid">
          <booking-resource-form
            v-model="form"
            :errors="errors.getAll()"
            @update-prop="clearErrorByName($event)"
          >
            <template v-slot:buttons>
              <v-btn
                large
                class="float-right"
                color="primary"
                :disabled="!valid"
                @click="submit"
              >
                {{ $t('BUTTON.SAVE') }}
              </v-btn>
            </template>
          </booking-resource-form>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import BookingResourceForm from '../components/forms/BookingResourceForm.vue';
import { isEmpty } from 'lodash';

export default {
  name: 'BookingResourceCreatePage',

  components: {
    BookingResourceForm
  },

  mixins: [errors],

  props: {},

  data: () => {
    return {
      valid: false,
      form: {}
    };
  },

  mounted() {
    if (!isEmpty(this.$route.params)) {
      this.form = { ...this.form, ...this.$route.params };
    } else {
      this.$router.push({
        name: 'booking-resources',
        params: { create_resource: true }
      });
    }
  },

  methods: {
    ...mapActions('booking_resources', ['storeBookingResource']),
    submit() {
      this.storeBookingResource({ resource: this.form })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
